<h2>Free cases</h2>
<div class="container free-cases-content">
  <div class="buttons">
    <mat-button-toggle-group class="filter-btn-toggle-group" name="filter" [formControl]="filterButton">
      <mat-button-toggle value="all">Все</mat-button-toggle>
      <mat-button-toggle value="used">Использованные</mat-button-toggle>
      <mat-button-toggle value="notUsed">Неиспользованные</mat-button-toggle>
    </mat-button-toggle-group>

    <button class="btn open-dialog" (click)="openAddFreeUserCasesDialog()">Добавить Free Case</button>
  </div>

  <div class="free-cases-table-container">
    <div class="progress-bar" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-table [dataSource]="userFreeCaseData" class="table free-cases-table" matSort #freeCasesSort>

      <!-- count Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef> #</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{i + 1}}</mat-cell>
      </ng-container>

      <!-- case-name Column -->
      <ng-container matColumnDef="case-name">
        <mat-header-cell *matHeaderCellDef>Название кейса</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="text-overflow">{{element.freeCase.name}}</span>
        </mat-cell>
      </ng-container>

      <!-- created Column -->
      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef>Создан</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.createdAt | date: 'dd.MM.yy HH:mm'}} </mat-cell>
      </ng-container>


      <!-- used Column -->
      <ng-container matColumnDef="used">
        <mat-header-cell *matHeaderCellDef>Использован</mat-header-cell>
        <mat-cell
          *matCellDef="let element"> {{element.usedAt ? (element.usedAt | date: 'dd.MM.yy HH:mm') : 'Нет' }} </mat-cell>
      </ng-container>


      <!-- agentKey Column -->
      <ng-container matColumnDef="agentKey">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Agent key</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.log?.agentKey || '-'}} </mat-cell>
      </ng-container>

      <!-- data Column -->
      <ng-container matColumnDef="data">
        <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{(element.log?.data || {}) | json}} </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="userFreeCaseColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: userFreeCaseColumns;"></mat-row>

      <div class="empty-data" *matNoDataRow>
        <p>Данные отсутствуют</p>
      </div>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]"></mat-paginator>
  </div>
</div>
